exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".singleLineMobile{float:none!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader!./components/xo-form-components/src/phone/phoneInputA/styles.less
// module id = ../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-form-components/src/phone/phoneInputA/styles.less
// module chunks = 1